import { render, staticRenderFns } from "./SuratPengantar.vue?vue&type=template&id=30465e83"
import script from "./SuratPengantar.vue?vue&type=script&lang=js"
export * from "./SuratPengantar.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports